import { render } from "./text.vue?vue&type=template&id=a646133e"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
script.render = render

export default script